// @ts-ignore

/**
 * this file is synced from dawn and its logic slightly modified
 */

const selectors = {
    customerAddresses: "main.account", // modified selector
    addressCountrySelect: "[data-address-country-select]",
    addressContainer: "[data-address]",
    toggleAddressButton: "button[aria-expanded].ignoreme", // modified selector
    cancelAddressButton: 'button[type="reset"].ignoreme', // modified selector
    deleteAddressButton: "button[data-confirm-message].ignoreme" // modified selector
};

const attributes = {
    expanded: "aria-expanded",
    confirmMessage: "data-confirm-message"
};

export class CustomerAddresses {
    elements: {
        container?: HTMLElement;
        addressContainer?: HTMLElement;
        toggleButtons?: NodeListOf<HTMLElement>;
        cancelButtons?: NodeListOf<HTMLElement>;
        deleteButtons?: NodeListOf<HTMLElement>;
        countrySelects?: NodeListOf<HTMLElement>;
    };

    constructor() {
        this.elements = this._getElements();
        if (Object.keys(this.elements).length === 0) return;
        this._setupCountries();
        this._setupEventListeners();
    }

    _getElements() {
        const container = document.querySelector<HTMLElement>(selectors.customerAddresses);
        return container
            ? {
                  container,
                  addressContainer: container.querySelector<HTMLElement>(selectors.addressContainer),
                  toggleButtons: document.querySelectorAll(selectors.toggleAddressButton) as NodeListOf<HTMLElement>,
                  cancelButtons: container.querySelectorAll(selectors.cancelAddressButton) as NodeListOf<HTMLElement>,
                  deleteButtons: container.querySelectorAll(selectors.deleteAddressButton) as NodeListOf<HTMLElement>,
                  countrySelects: container.querySelectorAll(selectors.addressCountrySelect) as NodeListOf<HTMLElement>
              }
            : {};
    }

    _setupCountries() {
        if (Shopify && Shopify.CountryProvinceSelector) {
            // eslint-disable-next-line no-new
            new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                hideElement: "AddressProvinceContainerNew"
            });
            this.elements.countrySelects.forEach((select) => {
                // @ts-ignore
                const formId = select.dataset.formId;
                // eslint-disable-next-line no-new
                new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
                    hideElement: `AddressProvinceContainer_${formId}`
                });
            });
        }
    }

    _setupEventListeners() {
        this.elements.toggleButtons.forEach((element) => {
            element.addEventListener("click", this._handleAddEditButtonClick);
        });
        this.elements.cancelButtons.forEach((element) => {
            element.addEventListener("click", this._handleCancelButtonClick);
        });
        this.elements.deleteButtons.forEach((element) => {
            element.addEventListener("click", this._handleDeleteButtonClick);
        });
    }

    _toggleExpanded(target: HTMLElement) {
        target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === "false").toString());
    }

    // @ts-ignore
    _handleAddEditButtonClick = ({ currentTarget }) => {
        this._toggleExpanded(currentTarget);
    };

    // @ts-ignore
    _handleCancelButtonClick = ({ currentTarget }) => {
        this._toggleExpanded(
            currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`)
        );
    };

    // @ts-ignore
    _handleDeleteButtonClick = ({ currentTarget }) => {
        // eslint-disable-next-line no-alert
        if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
            Shopify.postLink(currentTarget.dataset.target, {
                parameters: { _method: "delete" }
            });
        }
    };
}
